module.exports = "\n<div class=\"sticky-top\">\n  <div class=\"list-group\">\n    <a\n    class=\"list-group-item list-group-item-action\"\n    [class.active]=\"!category\"\n    routerLink=\"/\">\n     All Categories</a>\n\n   <a *ngFor=\"let c of categories$ | async\" \n   routerLink=\"/\"\n   [queryParams]=\"{category : c.$key}\"\n   [class.active]=\"category === c.$key\"\n   class=\"list-group-item list-group-item-action\">\n     {{c.name}}\n   </a>\n  \n</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/products/product-filter/product-filter.component.html
// module id = ./src/app/products/product-filter/product-filter.component.html
// module chunks = main